module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3c08P"))).then(() => parcelRequire('iDabs'));